/**
 * Data module for handling user info updates during card application flow.
 *
 * This module manages the state for user information updates specifically
 * for card applications, providing clean error handling separate from the
 * generic updateUserInfoContext data module.
 *
 * Key benefits:
 * - Dedicated error state management for card applications
 * - Prevents error message corruption from generic data modules
 * - Proper loading state management for form submissions
 * - Consistent with existing data module patterns
 */
import { createDataModule } from '@perpay-web/data-module/createDataModule';
import {
    updateUserInfoForCardApplication,
    updateUserInfoForCardApplicationSuccess,
    updateUserInfoForCardApplicationError,
    updateUserInfoForCardApplicationReset,
} from '@perpay-web/fintech/actions/entities/userInfo';

const UpdateUserInfoForCardApplicationDataModule = createDataModule({
    dataRequest: updateUserInfoForCardApplication,
    dataSuccess: updateUserInfoForCardApplicationSuccess,
    dataError: updateUserInfoForCardApplicationError,
    dataReset: updateUserInfoForCardApplicationReset,
});

const getRoot = (state) => state.dataModules.updateUserInfoForCardApplication;
const initialValue = {};

/**
 * Data module selectors and state management for card application user info updates.
 *
 * Provides:
 * - getErrors: Access to error state for UI display
 * - getIsLoading: Loading state for form submission buttons
 * - getData: Success response data
 * - reducer: Redux reducer for state management
 */
export const updateUserInfoForCardApplicationDataModule =
    UpdateUserInfoForCardApplicationDataModule({
        getRoot,
        initialValue,
    });
